var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9961 10.4069C19.9445 7.71764 19.5699 5.73415 19.575 5.73232C19.4191 5.42827 19.1458 5.17398 18.8114 5.04409C16.616 4.19266 14.4573 3.38002 12.3527 2.68666C12.1376 2.61568 11.9107 2.61568 11.6959 2.68666C9.5917 3.37819 7.43331 4.18937 5.23834 5.0397C4.94307 5.15422 4.69536 5.36607 4.53401 5.62365C4.54645 5.62512 4.08286 7.07221 4.00383 10.2683C3.957 13.4647 4.35509 14.4222 4.34191 14.4233C4.55742 15.1258 4.96063 15.8404 5.53837 16.567C6.18417 17.3786 7.05681 18.2168 8.11094 19.0408C9.85587 20.4103 11.4888 21.2288 11.5573 21.2577C11.7054 21.3302 11.8624 21.3671 12.0241 21.3668C12.1862 21.3668 12.3432 21.3298 12.491 21.257C12.5598 21.2281 14.1946 20.4071 15.9388 19.0379C16.9933 18.2132 17.8659 17.3749 18.5121 16.5638C19.1312 15.7855 19.5497 15.0219 19.7521 14.2718C19.744 14.2707 20.0367 13.0969 19.9961 10.4073V10.4069ZM12.8928 12.5046V14.2085C12.8928 14.6886 12.5038 15.0775 12.0238 15.0779C11.5437 15.0779 11.1544 14.6889 11.1544 14.2089V12.5287C10.528 12.2173 10.097 11.5712 10.097 10.8244C10.097 9.77357 10.9488 8.92142 11.9996 8.92142C13.0505 8.92142 13.9022 9.77321 13.9026 10.824C13.9026 11.5522 13.4935 12.1848 12.8928 12.5046Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/privacy_policy.2fe169f37ed783b35c8487b70be64c7a.svg";
export { ForwardRef as ReactComponent };